import { BriefcaseBusiness, Building2, Layers, ReceiptText } from 'lucide-react'

export const CUSTOMER_DOCUMENT_SECTIONS = [
  { key: 'rental', label: '租赁订单', Icon: Building2, permission: 'order' },
  { key: 'service', label: '服务订单', Icon: BriefcaseBusiness, permission: 'order' },
  { key: 'bills', label: '账单', Icon: ReceiptText, permission: 'bill' },
  { key: 'groups', label: '账单组', Icon: Layers, permission: 'bill' }
] as const
